export const DEFAULT_CROP = { top: 0, right: 0, bottom: 0, left: 0 }

// x/y — percent of the canvas, top-left of the template box (same convention as
// FieldPlacement.x/y) — win over the named anchor when both are set, direct
// left/top with no transform. Mirrors OverlayRenderService.ApplyTemplateLayout
// on the backend exactly, so Edit == Preview == render.
export const positionStyle = (pos, scale, crop = DEFAULT_CROP, x = null, y = null) => {
  const base = { position: 'absolute', width: `${scale}%` }
  if (x != null && y != null) {
    base.left = `${x}%`
    base.top = `${y}%`
    return base
  }
  const [v, h] = pos.includes('-') ? pos.split('-') : ['center', pos === 'center' ? 'center' : pos]

  let tx = 0, ty = 0

  if (v === 'top')    { base.top = 0;    ty = -crop.top }
  if (v === 'center') { base.top = '50%'; ty = -50 + (crop.top - crop.bottom) / 2 }
  if (v === 'bottom') { base.bottom = 0;  ty = crop.bottom }

  if (h === 'left')   { base.left = 0;   tx = -crop.left }
  if (h === 'center') { base.left = '50%'; tx = -50 + (crop.left - crop.right) / 2 }
  if (h === 'right')  { base.right = 0;  tx = crop.right }

  base.transform = `translate(${tx}%, ${ty}%)`

  return base
}
